import axios from "./HTTP";

export default {
  getStates() {
    return [
      "AK",
      "AL",
      "AZ",
      "AR",
      "CA",
      "CO",
      "CT",
      "DE",
      "FL",
      "GA",
      "HI",
      "ID",
      "IL",
      "IN",
      "IA",
      "KS",
      "KY",
      "LA",
      "ME",
      "MD",
      "MA",
      "MI",
      "MN",
      "MS",
      "MO",
      "MT",
      "NE",
      "NV",
      "NH",
      "NJ",
      "NM",
      "NY",
      "NC",
      "ND",
      "OH",
      "OK",
      "OR",
      "PA",
      "RI",
      "SC",
      "SD",
      "TN",
      "TX",
      "UT",
      "VT",
      "VA",
      "WA",
      "WV",
      "WI",
      "WY"
    ];
  },

  getGeotagStates(params, callback, errorCallback) {
    axios
      .get("/api/collections/geotag_states.json", { params })
      .then(response => callback(response.data))
      .catch(error => errorCallback(error));
  },

  getGeotagSegments(params, callback) {
    axios
      .get('/api/collections/geotag_segments')
      .then(response => callback(response.data));
  },

  getManagers(params, callback, errorCallback) {
    axios
      .get("/api/managers.json", { params })
      .then(response => callback(response.data))
      .catch(error => errorCallback(error));
  },

  getManagersList(params, callback, errorCallback) {
    axios
      .get("/api/managers_list.json", { params })
      .then(response => callback(response.data))
      .catch(error => errorCallback(error));
  },

  getBoh(callback, errorCallback) {
    axios
      .get("/api/managers.json")
      .then(response => callback(response.data))
      .catch(error => errorCallback(error));
  },

  getLocations(callback) {
    axios
      .get("/api/collections/worksites.json")
      .then(response => callback(response.data));
  },

  getWorksiteColorCategories(callback, errorCallback) {
    axios
      .get("/api/collections/worksite_color_categories.json")
      .then(response => callback(response.data))
      .catch(error => errorCallback(error));
  },

  getClientBusinesses(callback, errorCallback) {
    axios
      .get("/api/collections/client_businesses.json")
      .then(response => callback(response.data))
      .catch(error => errorCallback(error));
  },

  getEmployees(callback) {
    axios
      .get("/api/collections/employees.json")
      .then(response => callback(response.data));
  },

  getManagedEmployees(callback) {
    axios
      .get("/api/collections/managed_employees.json")
      .then(response => callback(response.data));
  },

  getSkills(callback, errorCallback) {
    axios
      .get("/api/collections/skills.json")
      .then(response => callback(response.data))
      .catch(error => errorCallback(error));
  },

  getPositions(callback, errorCallback) {
    axios
      .get("/api/collections/positions.json")
      .then(response => callback(response.data))
      .catch(error => errorCallback(error));
  },

  get(clientId, callback) {
    axios
      .get(`/api/client_businesses/${clientId}.json`)
      .then(response => callback(response.data));
  },

  getAllTasksUsers(callback) {
    axios
      .get(`/api/collections/all_tasks_users.json`)
      .then(response => callback(response.data));
  }
};
